import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReply, faCheck, faEye } from "@fortawesome/free-solid-svg-icons";

export const tableConstants = (
  permissions,
  openReplyModal,
  closeAppointment,
  viewAppointment,
) => {
  let formatedData = [
    {
      title: "SNo",
      render: (_, index) => {
        return <span>{index + 1}</span>;
      },
    },

    {
      title: "Admission_No",
      render: (rowData) => {
        return <span>{rowData.student?.id_number ?? "-"}</span>;
      },
    },

    {
      title: "Student_Name",
      render: (rowData) => {
        return <span>{rowData.student?.full_name ?? "-"}</span>;
      },
    },
    {
      title: "Class",
      render: (rowData) => {
        return (
          <span>{rowData.student?.student_program?.program_name ?? "-"}</span>
        );
      },
    },
    {
      title: "Meeting_With",
      render: (rowData) => {
        return <span>{rowData.meeting_with ?? "-"}</span>;
      },
    },

    {
      title: "Duration",
      render: (rowData) => {
        return <span>{rowData.duration ?? "-"}</span>;
      },
    },

    {
      title: "Purpose",
      render: (rowData) => {
        return (
          <div
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              minWidth: "200px",
              maxWidth: "300px",
            }}
          >
            {rowData.purpose ?? "-"}
          </div>
        );
      },
    },

    {
      title: "Requested_On",
      render: (rowData) => {
        return <span>{rowData.requested_at ? rowData.requested_at : "-"}</span>;
      },
    },
    {
      title: "Meeting_Date",
      render: (rowData) => {
        return <span>{rowData.meeting_date ? rowData.meeting_date : "-"}</span>;
      },
    },
    {
      title: "Meeting_Time",
      render: (rowData) => {
        return <span>{rowData.meeting_time ? rowData.meeting_time : "-"}</span>;
      },
    },
    {
      title: "Status",
      render: (rowData) => {
        return (
          <span
            className={`badge ${
              rowData.status === 1
                ? "bg-warning"
                : rowData.status === 2
                  ? "bg-success"
                  : rowData.status === 3
                    ? "bg-secondary"
                    : rowData.status === 4
                      ? "bg-danger"
                      : "bg-info"
            }`}
          >
            {rowData.status_label}
          </span>
        );
      },
    },
    {
      title: "View",
      render: (rowData) => {
        return (
          <span>
            <FontAwesomeIcon
              icon={faEye}
              color="blue"
              style={{ cursor: "pointer" }}
              onClick={() => viewAppointment(rowData)}
            />
          </span>
        );
      },
    },
    {
      title: "Action",
      render: (rowData) => {
        return (
          <span>
            {permissions.includes("appointment.reply") && (
              <FontAwesomeIcon
                icon={faReply}
                title="Reply"
                style={{
                  color: "var(--color-primary-text)",
                  marginRight: "12px",
                  cursor: "pointer",
                }}
                onClick={() => openReplyModal(rowData)}
              />
            )}
            {/* Close */}
            {permissions.includes("appointment.reply") && (
              <FontAwesomeIcon
                icon={faCheck}
                color="green"
                title="Close"
                style={{
                  marginRight: "10px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (
                    window.confirm(
                      "Are you sure you want to close this appointment?",
                    )
                  ) {
                    closeAppointment(rowData.id);
                  }
                }}
              />
            )}{" "}
          </span>
        );
      },
    },
  ];
  return formatedData;
};
